<script setup lang="ts">

import {defineProps} from "vue";
import PlanetDefenseTroops from '@/components/Sections/Planets/PlanetTabs/DefenceTab/PlanetDefenseTroops.vue'
import PlanetDefensePlanetaryShields
  from '@/components/Sections/Planets/PlanetTabs/DefenceTab/PlanetDefensePlanetaryShields.vue'
import PlanetDefenseActive from '@/components/Sections/Planets/PlanetTabs/DefenceTab/PlanetDefenseActive.vue'
import PlanetDefensePassive from '@/components/Sections/Planets/PlanetTabs/DefenceTab/PlanetDefensePassive.vue'

/**
 * Props
 */
const props = defineProps({
  planetId: {
    type: Number,
    required: true
  }
});




</script>

<template>
  <div class="flex flex-col xl:flex-row">
    <div class="flex-col xl:w-1/2">
      <PlanetDefenseTroops :planetId="props.planetId"/>
      <PlanetDefenseActive :planetId="props.planetId"/>
    </div>
    <div class="flex-col xl:w-1/2 ps-0 xl:ps-2">
      <PlanetDefensePlanetaryShields :planetId="props.planetId"/>
      <PlanetDefensePassive :planetId="props.planetId"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>
